import { action, makeAutoObservable } from "mobx";
import mapboxgl, { Map, LngLatBounds } from "mapbox-gl";
import gjv  from './geojsonValidation'
import {
    generatePolygonDrawLayer,
    disablePolygonDrawTool,
    disablePolygonDeleteTool,
    setDrawModeToSelect,
    DrawStatus,
    PolygonStatus,
    MapHelpMessage,
    generatePolygonLayer
} from "./mapboxUtil";
import { LatLng, Polygon, MapboxPolyCoords } from '../types'
import { requests } from "./apiagent";
import API_URL from "../config";
import { ChangeEvent, ChangeEventHandler } from "react";
import DrawControl from "react-mapbox-gl-draw";
import { timeout } from "d3";

class MapboxStore {
    AUcenter: LatLng = { lat: -28.25, lng: 133.416667 };
    AUbounds = new LngLatBounds([[90, -50], [180, -10.47]]); // [sw,ne]
    AUSearchBounds = [90, -44, 180, -10]; // minLon,minLat,maxLon,maxLat
    zoom: number = 3
    center: MapboxPolyCoords = [this.AUcenter.lng, this.AUcenter.lat]

    polygons: Array<Polygon> = []
    area: number = 0
    areaLargeAlert: boolean = false
    helperMessage: MapHelpMessage = MapHelpMessage.Init
    drawControl: DrawControl|null = null

    loadFileModelOpen: boolean = false
    fileContent: string = ''
    fileContentVerify: Array<string> = []

    constructor() {
        makeAutoObservable(this)
    }
    getCenterOfPolygon(){
        if(this.polygons.length==0){
            return this.AUcenter
        }else{
            let bounds = new LngLatBounds()
            this.polygons[0].forEach(ele=>bounds.extend(ele))
            return bounds.getCenter()
        }
    }
    onLoadFileModalOpen = () => {
        this.loadFileModelOpen = true
    }
    onLoadFileChange = (event: ChangeEvent<HTMLInputElement|HTMLTextAreaElement>) => {
        const input = event.target as HTMLInputElement
        if(input.files&& input.files.length>0){
            const file = input.files[0]
            file.text().then(action(text=>this.fileContent=text))
        }

    }

    onFileContentChange = (event: ChangeEvent<HTMLInputElement|HTMLTextAreaElement>) =>{
        const input = event.target as HTMLTextAreaElement
        this.fileContent = input.value
    }
    onLoadFileModalClose = () => {
        this.loadFileModelOpen = false
    }
    onLoadFileSubmit = () => {
        let messages = this.verifyGeoJSON(this.fileContent)
        if(messages.length == 0){
            let jsonObj = JSON.parse(this.fileContent)
            this.savePolygon(jsonObj['features'][0]['geometry']['coordinates'][0])
            this.loadFileModelOpen = false
            disablePolygonDrawTool(
                DrawStatus.Disable,
                PolygonStatus.Valid
            );
            disablePolygonDeleteTool(false);
            this.repaintDraw(jsonObj)
            //this.fitPolyBounds(jsonObj)
            
        }else{
            this.fileContentVerify = messages
        }
    }
    
    verifyGeoJSON(geojson: string): Array<string>{
        let jsonObj
        try{
            jsonObj = JSON.parse(geojson)
        }catch{
            return ['Invalid JSON ']
        }
        let messages = gjv.isGeoJSONObject(jsonObj, true)
        //@ts-ignore
        if(messages.length == 0){
            let polygonVerify = gjv.isPolygon(jsonObj['features'][0]['geometry'], true)
            console.log(jsonObj)
            //@ts-ignore
            if(polygonVerify.length == 0){
                return []
            }else{
                //@ts-ignore
                return polygonVerify
            }
        }else{
            //@ts-ignore
            return messages
        }
    }

    savePolygon = (coords: Polygon) => {
        this.polygons = [coords]
        this.queryAreaSize()
    }
    onDownloadFile = () =>{
        const a = document.createElement('a');
        let content = this.fileContent
        if(!content){
            content = JSON.stringify(generatePolygonDrawLayer(this.polygons[0]))
        }
        const file = new Blob([content], {type: 'application/json'});
        
        a.href= URL.createObjectURL(file);
        a.download = (new Date()).toISOString()+'.json';
        a.click();
    }

    updateHelperBox = (text: MapHelpMessage) => {
        this.helperMessage = text
    }

    clearPolygons = () => {
        this.polygons = []
        // this.area = 0
    }
    // getArea = () =>  Math.ceil(this.area)
    

    setDrawControl = (drawControl: DrawControl|null) => {
        this.drawControl = drawControl
    }
    repaintDraw = (geojson: JSON) =>{
        if(!this.drawControl) return
        //@ts-ignore
        this.drawControl.draw&&this.drawControl.draw.deleteAll()
        //@ts-ignore
        this.drawControl.draw&&this.drawControl.draw.add(geojson)
        this.fitBounds(this.drawControl.context)
        console.log(this.drawControl.context);
    }

    /* Trying to debug the zoom-to-bounds and then back out...
    fitPolyBounds = (map: mapboxgl.Map|undefined) =>{
        this.fitBounds(map)
    }
    */
    
    fitBounds = (map: mapboxgl.Map|undefined) => {
        if(map){
            const bounds = new LngLatBounds();
            if(this.polygons[0].length>0){
                this.polygons[0].forEach(ele=>bounds.extend(ele))
            }
            console.log(bounds)
            map.fitBounds(bounds, {
                padding: { top: 10, bottom: 10, left: 10, right: 10 },
                animate: true
              })
            // console.log(this.zoom, map.getZoom())
            // timeout(()=>console.log(this.zoom, map.getZoom()), 10000)
            // this.zoom = map.getZoom()||this.zoom
        }

    }

    onZoomChanged = (map: mapboxgl.Map) => {
        this.saveMapView(map);
    };

    onDrawCreate = (draw: any) => {
        const features = draw.features;
        if (features && features.length > 0) {
            const feature = features[0];
            if (feature.geometry.type === "LineString") {
                const coords = feature.geometry.coordinates as Array<Array<Number>>;
                const firstCoord = coords[0];
                const lastCoord = coords[coords.length - 1];
                // auto close the polygon when double click or press enter
                if (firstCoord[0] !== lastCoord[0] || firstCoord[1] !== lastCoord[1])
                    coords.push(firstCoord);

                // prevent user finish draw (double click or click to the start point) earier before finish polygon
                if (coords.length > 3) {
                    // conver line string drawing to polygon
                    //@ts-ignore
                    const drawcontrol = draw.target._controls.filter(c => c.modes); //just hope nothing else has a 'modes' prop
                    if (drawcontrol && drawcontrol[0]) {
                        // delete line strings
                        drawcontrol[0].delete(feature.id);
                        // add generated polygon layer to draw control
                        const feature_id = drawcontrol[0].add(
                            generatePolygonDrawLayer(coords as Polygon)
                        );
                        // Use changeMode method to force the draw tool change mode with polygon selected
                        drawcontrol[0].changeMode("simple_select", {
                            featureIds: feature_id
                        });

                        this.savePolygon(coords as Polygon)
                        disablePolygonDrawTool(
                            DrawStatus.Disable,
                            PolygonStatus.Valid
                        );
                        disablePolygonDeleteTool(false);
                        //   ReactGA.event(completePolygon(polygonFormat));
                    }
                } else {
                    // @ts-ignore
                    const drawcontrol = draw.target._controls.filter(c => c.modes); //just hope nothing else has a 'modes' prop
                    // delete all line strings if they are not valid
                    if (drawcontrol && drawcontrol[0]) drawcontrol[0].deleteAll();
                }
            }
        }
    };

    // @ts-ignore
    onDrawUpdate = (draw: any) => {
        const features = draw.features;
        if (features.length > 0) {
            const coords = features[0].geometry.coordinates[0]
            // let polygonFormat: Polygon = coords as Polygon
            this.clearPolygons();
            this.savePolygon(coords);
        }
    };

    onDrawDelete = () => {
        this.clearPolygons();
        this.updateHelperBox(MapHelpMessage.Init);
        disablePolygonDrawTool(
            DrawStatus.Enable,
            PolygonStatus.Valid
        );
        disablePolygonDeleteTool(true);
        //@ts-ignore
        this.drawControl&&this.drawControl.draw.deleteAll()
    };

    saveMapView(map: Map) {
        this.zoom = map.getZoom();
        const center = map.getCenter();
        this.center = [center.lng, center.lat]
    }

    onDrawSelectionChange = (draw: any) => {
        this.saveMapView(draw.target);
        if (draw.features.length === 0) {
            setDrawModeToSelect(draw.target);
        }
    };
    onDrawModeChange = (draw: any) => {
        disablePolygonDeleteTool(true);
        this.saveMapView(draw.target);
        if (draw.mode === "draw_line_string") {
            // disable polygon drawing tool on the tool is clicked
            disablePolygonDrawTool(
                DrawStatus.Disable,
                PolygonStatus.Valid
            );
            this.updateHelperBox(MapHelpMessage.DrawPolygon);
        } else if (draw.mode === "simple_select") {
            //@ts-ignore
            const drawcontrol = draw.target._controls.filter(c => c.modes); //just hope nothing else has a 'modes' prop
            const features = drawcontrol[0].getAll().features;
            // update text and disable area tool when the polygon added success
            if (features && features.length > 0) {
                this.updateHelperBox(MapHelpMessage.CompletePolygon);
                setDrawModeToSelect(draw.target);
                disablePolygonDeleteTool(false);
            } else {
                // init the text and area tool if the feature is empty
                this.updateHelperBox(MapHelpMessage.Init);
                disablePolygonDrawTool(
                    DrawStatus.Enable,
                    PolygonStatus.Valid
                );
                disablePolygonDeleteTool(true);
            }
        } else if (draw.mode === "direct_select") {
            // this.updateHelperBox(MapHelpMessage.EditPolygon)
            setDrawModeToSelect(draw.target);
            disablePolygonDeleteTool(false);
        }
    };

    queryAreaSize(){
        let data = this.polygons[0].map(ele=>{return {lng: ele[0], lat: ele[1]}})
        requests.post(API_URL.ROOT_URL+API_URL.AREA, {polygon: JSON.stringify(generatePolygonDrawLayer(this.polygons[0]))}).then(action('queryAreaSize', res=>{
            //@ts-ignore
            const size = res['area']
            this.area = Math.round(size)
            if(size > 1000000){
                this.areaLargeAlert = true
            }
            if(size <= 1){
                this.areaLargeAlert = true
            }
        }))
    }
    closeAreaLargeAlert = () =>{ 
        this.onDrawDelete()
        this.areaLargeAlert = false
    }
}

export default new MapboxStore();
